import React, { useContext, useEffect } from 'react';
import { appContext } from "../AppContext";
import Profile from './../components/larper/Profile'
import { Button, message, Select} from 'antd';
import {useFetch} from './../utils/hooks/useFetch'
import {
    Mobile,
    // DefaultDevice
  } from '../utils/mediaQuery'

  const { Option } = Select;

export default function ProfilePage() {
    
    // eslint-disable-next-line
    const [appState, AppDispatch] = useContext(appContext);
    const [doFetch, FetchOptions] = useFetch();

    useEffect(() => {
        AppDispatch({ type: "SETSELECTEDPAGE", payload: "Profile" })
      }, // eslint-disable-next-line
      [])

    function handleChangeSelectStory(value) {

    const selectedStory = appState.stories.find(story => story.id === value)
    AppDispatch({ type: "SETSTORYID", payload: {storyId:value, storyName:selectedStory.name} })
    localStorage.setItem('LarpTOM.StoryId', value);
    localStorage.setItem('LarpTOM.StoryName', selectedStory.name);
    }

    const storyOptions = appState.stories.map(story => {
        if(story.name === "Zivania" && !appState.user.isAdmin) {
            return null;
          }
    return (<Option 
        value={story.id} 
        key={story.id}
    >
        {story.name}
    </Option>)
    })

    function logOut() {

        const url = `/api/Account/LogOut`;
        doFetch(url)
        .then((response) => {
            if(response.result.status === 200) {
                AppDispatch({ type: "LOGOUT" })
                return;
            }
            message.error('LogOut failed')
        })
      }


    return (
        <>
            <Mobile>
            {appState.user !== undefined && <div className="gridmenu">
                <Button onClick={logOut}>Logout</Button>
            </div>}
                    <Select 
                        onChange={handleChangeSelectStory}
                        value={parseInt(appState.storyId)}
                        >
                            {storyOptions} 
                    </Select>
            </Mobile>
            <Profile />

        </>
        
        
    )
}